import styled from "styled-components";

export const ContainerHeader = styled.div`
  height: 60px;
  background: ${(props) => props.theme.colors.primary};
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
`;
